import IRepository from "@/contracts/IRepository";
import LocalRepository from "@/infrastructure/repositories/LocalRepository";

export default class RepositoryFactory {
    static default(): IRepository {
        return new LocalRepository()
    }
}
